import axios, { AxiosInstance } from 'axios';
import { ENVIRONMENTS } from '../constants/environments';

const DEFAULT_API_VERSION = 'v1';

export type CreateApiOptions = {
  baseURL: string;
  onUnauthorized?: () => void;
  // Defaults to true to match the original api.ts behavior for real, cookie-authenticated
  // backends. Set false for a stateless backend on another origin (e.g. a signed-token mock) -
  // withCredentials:true requires the server to send Access-Control-Allow-Credentials, which
  // turns a same-origin-by-default CORS setup into something that needs an exact allow-listed
  // origin and more care; skip that entirely when no cookie is actually involved.
  withCredentials?: boolean;
};

export function createApi({ baseURL, onUnauthorized, withCredentials = true }: CreateApiOptions): AxiosInstance {
  const instance = axios.create({
    baseURL,
    withCredentials,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });

  if (onUnauthorized) {
    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error?.response?.status === 401) {
          onUnauthorized();
        }

        return Promise.reject(error);
      },
    );
  }

  return instance;
}

export const api = createApi({ baseURL: `${ENVIRONMENTS.API_URL}/${DEFAULT_API_VERSION}` });
